import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { META_PIXEL_ID, initMetaPixel, trackPageView } from '../utils/metaPixel';

/**
 * Loads the Meta Pixel once and fires a PageView on every route change
 * (the funnel is a SPA, so each page is a client-side navigation).
 */
export function MetaPixel() {
  const {
    pathname
  } = useLocation();
  const ready = useRef(false);
  if (!ready.current) {
    initMetaPixel();
    ready.current = true;
  }
  useEffect(() => {
    trackPageView();
  }, [pathname]);
  return <noscript data-id="element-37" data-mp="2bzslf2ckq44v">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-38" data-mp="2by8105jz41kq" />
    </noscript>;
}